
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chat-landings/teses-juridicas/[id]",
      function () {
        return require("private-next-pages/chat-landings/teses-juridicas/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chat-landings/teses-juridicas/[id]"])
      });
    }
  